import React, {Component} from 'react';
import './App.css';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import VideoPlayer from "./VideoPlayer";
import TextField from '@material-ui/core/TextField';
import axios from "axios";
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography';
import VideoInfo from "./VideoInfo"
// import sampleResponse from "./sampleResponse"
import CardContent from '@material-ui/core/CardContent'
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Tooltip from '@material-ui/core/Tooltip';
import FormGroup from '@material-ui/core/FormGroup'
import PlayArrow from '@material-ui/icons/PlayArrow'
import FastForward from '@material-ui/icons/FastForward'
import PlayCircleFilled from '@material-ui/icons/PlayCircleFilled'
import PauseCircleFilled from '@material-ui/icons/PauseCircleFilled'
import OpenInNew from '@material-ui/icons/OpenInNew'
import IconButton from '@material-ui/core/IconButton'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import green from '@material-ui/core/colors/green'
import CircularProgress from '@material-ui/core/CircularProgress'
import Input from '@material-ui/core/Input'
import Fab from '@material-ui/core/Fab';
import qs from "qs";
import NetworkInfo from "./NetworkInfo";


import ReactGA from 'react-ga';

import {urlConfig} from './config'
import ContentSearch from "./ContentSearch";
import ErrorBoundary from "./ErrorBoundry";
import ContentService from "./Services/ContentService";

const propTypes = {};

let videoPlayerOptions = {
    width: 1008,
    height: 567,
    autoplay: true,
    controls: true,
    sources: []
};

class DRMPlayer extends React.Component {
    constructor(props) {
        super(props);
        console.log("in content pl");
        console.log({props});
        this.state = {
            videoPlayerConfig: {}
        }
    }

    componentWillMount() {

    }

    componentWillReceiveProps(nextProps) {
        // You don't have to do this check first, but it can help prevent an unneeded render
        if (nextProps.startTime !== this.state.videoPlayerConfig.startTime) {
            let videoPlayerConfig = this.state.videoPlayerConfig;
            videoPlayerConfig.startTime = nextProps.startTime;
            this.setState({videoPlayerConfig});
        }
    }

    componentDidMount() {

        let videoPlayerConfig = {};

        videoPlayerConfig.width = this.props.width;
        videoPlayerConfig.height = this.props.height;
        videoPlayerConfig.autoplay = this.props.autoplay;
        videoPlayerConfig.sources = this.props.sources;
        videoPlayerConfig.cid = this.props.cid;
        videoPlayerConfig.startTime = this.props.startTime;
        videoPlayerConfig.drmToken = this.props.drmToken;
        videoPlayerConfig.drmType = "wideVine";

        let url = this.props.url;
        let sources = [
            {
                file: url
            }
        ];

        videoPlayerConfig.sources = sources;

        videoPlayerConfig.cid = this.state.cid;

        this.setState({videoPlayerConfig: videoPlayerConfig});
    }


    render() {

        return (
            <>
                {this.state && this.state.videoPlayerConfig && this.state.videoPlayerConfig.sources && this.state.videoPlayerConfig.sources.length > 0 && this.state.videoPlayerConfig.drmToken &&
                <VideoPlayer {...this.state.videoPlayerConfig}></VideoPlayer>
                }
            </>
        )
    }
}

DRMPlayer.propTypes = propTypes;
export default DRMPlayer;